import MealFinder from "../MealFinder/MealFinder";

const Home = () => {
    
    return (
        <div style={{textAlign: 'center', marginTop: '30px'}}>
            <h1>All Meals</h1>
            <MealFinder />
        </div>
    );
};

export default Home;